import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-terms-and-condition",
  templateUrl: "./terms-and-condition.component.html",
  styleUrls: ["./terms-and-condition.component.scss"],
})
export class TermsAndConditionComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    let element = document.querySelector(".navbar");
    element.classList.replace("theme_menu_1", "theme_menu");
    window.scroll(0, 0);
  }
}
